<template>
  <article class="case-study-card">
    <h3>{{ study.title }}</h3>
    <p>{{ study.summary }}</p>
    <p class="challenge"><strong>Business Challenge:</strong> {{ study.businessChallenge }}</p>

    <ul aria-label="Outcome list">
      <li v-for="item in study.outcome" :key="item">{{ item }}</li>
    </ul>

    <router-link :to="`/case-studies/${study.slug}`" class="link-button">
      Read Full Case Study
    </router-link>
  </article>
</template>

<script>
export default {
  name: "CaseStudyCard",
  props: {
    study: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.case-study-card {
  background: linear-gradient(150deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.015));
  border: 1px solid var(--border-color);
  border-radius: 20px;
  padding: 1.6rem;
  backdrop-filter: blur(8px);
  display: grid;
  gap: 1rem;
  min-height: 100%;
}

h3 {
  margin: 0;
  font-family: var(--font-display);
  font-size: 1.25rem;
  color: var(--text-primary);
}

p {
  margin: 0;
  color: var(--text-secondary);
  line-height: 1.7;
}

.challenge {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 0.8rem;
}

ul {
  margin: 0;
  padding-left: 1.15rem;
  color: var(--text-secondary);
  line-height: 1.6;
}

.link-button {
  align-self: end;
  justify-self: start;
  text-decoration: none;
  color: var(--text-primary);
  border-bottom: 1px solid rgba(245, 245, 240, 0.5);
  padding-bottom: 0.2rem;
}

.link-button:hover,
.link-button:focus-visible {
  border-color: var(--accent);
  color: var(--accent);
}
</style>
